export default {
  header: {
    title: 'Cadeaukaart kopen',
  },
  checkout_btn: {
    title: 'Afrekenen',
  },
  items: {
    gift_card: {
      online: 'Cadeaukaart alleen online inwisselbaar',
      online_and_store: 'Cadeaukaart (online & in de winkel inwisselbaar)',
      title: 'Kies het gewenste bedrag',
      description: 'Voeg de cadeaukaart met het gewenste aantal toe aan de winkelwagen',
    },
    expiration: {
      label: '3 jaar geldig',
      title: 'Veel plezier met geven!',
      description: 'De ontvanger kan de voucher flexibel binnen 3 jaar inwisselen.',
    },
    delivery: {
      label: 'Direct afgeleverd als pdf via e-mail',
      title: 'Directe levering als pdf via e-mail',
      description: 'Na veilige betaling ontvang je de voucher direct.',
    },
  },
  form: {
    value: {
      title: 'Kies het bedrag van de cadeaukaart',
      custom: {
        label: 'Aangepast',
        placeholder: 'Voer een bedrag in tussen {{min}} en {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Aantal',
    },
    email: {
      title: 'Wat is je e-mailadres zodat we je de cadeaukaart kunnen sturen?',
      placeholder: 'Je e-mailadres',
      error: 'Ongeldig e-mailadres',
    },
  },
  confirmation: {
    title: {
      title: 'Cadeaukaart kopen?',
      subtitle_one: 'Wil je 1 cadeaukaart kopen voor {{value}}?',
      subtitle_other: 'Wil je {{count}} cadeaukaarten kopen voor {{value}}?',
    },
    description: {
      total: 'Totaal:',
      email: 'E-mail:',
      quantity: 'Aantal',
      amount: 'Bedrag',
    },
    footer: {
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
    },
  },
};
